import { Box, List, useMediaQuery, useTheme } from '@mui/material';
import SidebarItem from 'components/Layouts/components/SidebarItem';
import SidebarSectionLabel from 'components/Layouts/components/SidebarSectionLabel';
import * as urls from 'routes/config';
import { Outlet } from 'react-router-dom';

const configBase = `/agency/${urls.agency.configuration}`;
const CHILD_SIDEBAR_WIDTH = { md: 180, lg: 220 };

export default function Configuration() {
  const theme = useTheme();
  const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <Box
      display='flex'
      flexDirection={{ xs: 'column', md: 'row' }}
      alignItems={{ md: 'flex-start' }}
      gap={{ xs: 0, md: 4 }}
      minHeight='calc(100vh - 64px)'
      sx={{ width: '100%' }}
    >
      {!isMediumScreen ? (
        <>
          {/* Keeps content offset while the real nav is fixed to the viewport */}
          <Box
            sx={{
              width: CHILD_SIDEBAR_WIDTH,
              flexShrink: 0,
              visibility: 'hidden',
              pointerEvents: 'none'
            }}
            aria-hidden
          />
          <List
            disablePadding
            sx={{
              width: CHILD_SIDEBAR_WIDTH,
              height: 'fit-content',
              background: theme.palette.background.paper,
              borderRadius: 2,
              position: 'fixed',
              top: '48%',
              left: { md: '256px', lg: '264px' },
              transform: 'translateY(-50%)',
              py: 0.5,
              zIndex: 2,
              boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.04)'
            }}
          >
            <SidebarSectionLabel label='Whitelabel & Setup' />
            <SidebarItem to={`${configBase}/${urls.configuration.branding}`} label='Branding' />
            <SidebarItem to={`${configBase}/${urls.configuration.smtp}`} label='Email (SMTP)' />
            <SidebarItem to={`${configBase}/${urls.configuration.pricing}`} label='Pricing Packages' />
            <SidebarItem to={`${configBase}/${urls.configuration.coupons}`} label='Coupons' />

            <SidebarSectionLabel label='Agency Only' />
            <SidebarItem to={`${configBase}/${urls.configuration.thirdParty}`} label='Third-Party Apps' />
            <SidebarItem to={`${configBase}/${urls.configuration.apiKeys}`} label='API Keys' />
            <SidebarItem to={`${configBase}/${urls.configuration.webhooks}`} label='Webhooks' />
          </List>
        </>
      ) : (
        <List
          sx={{
            display: 'flex',
            flexDirection: 'row',
            height: 'fit-content',
            background: theme.palette.background.paper,
            borderRadius: '12px',
            position: 'fixed',
            bottom: '0px',
            left: { xs: '12px', sm: '24px' },
            right: { xs: '12px', sm: '24px' },
            overflowX: 'auto',
            overflowY: 'hidden',
            zIndex: 1000,
            backgroundColor: theme.palette.background.default,
            padding: { xs: '8px', sm: '12px' },
            gap: { xs: 1, sm: 1.5 },
            '&::-webkit-scrollbar': {
              display: 'none'
            },
            scrollbarWidth: 'none',
            msOverflowStyle: 'none'
          }}
        >
          <SidebarItem type='mobile' to={`${configBase}/${urls.configuration.branding}`} label='Branding' />
          <SidebarItem type='mobile' to={`${configBase}/${urls.configuration.smtp}`} label='Email (SMTP)' />
          <SidebarItem type='mobile' to={`${configBase}/${urls.configuration.pricing}`} label='Pricing Packages' />
          <SidebarItem type='mobile' to={`${configBase}/${urls.configuration.coupons}`} label='Coupons' />
          <SidebarItem type='mobile' to={`${configBase}/${urls.configuration.thirdParty}`} label='Third-Party Apps' />
          <SidebarItem type='mobile' to={`${configBase}/${urls.configuration.apiKeys}`} label='API Keys' />
          <SidebarItem type='mobile' to={`${configBase}/${urls.configuration.webhooks}`} label='Webhooks' />
        </List>
      )}
      <Box
        width='100%'
        sx={{
          paddingBottom: { xs: '80px', md: '100px' },
          paddingX: { xs: 0, md: 0 },
          overflowX: 'hidden'
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}
